module.exports = {"id":"210514","name":"João Cancelo","rating":"78","photo":"./data/images/photos/4/210514.png","club":{"name":"Inter","logo":"./data/images/clubs/Inter.png"},"positions":["DD","MD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JoaoCancelo0.json
// module id = 2030
// module chunks = 0